function o(t,...n){return t.reduce((e,a,u)=>{var r;let i=(r=n.at(u))!=null?r:"";return e+a+String(i)},"")}

export { o as a };
